import { AccountInjuryOutlineIcon } from './AccountInjuryOutlineIcon';

/**
 * author: Google
 * id DB3273BF-116D-4AD9-8302-16CE79B64498
 * name account-injury-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-injury-outline.svg
 * tags
 * - Account / User 
 * - Medical / Hospital 
 */
export const PersonInjuryOutlineIcon = AccountInjuryOutlineIcon;
export default PersonInjuryOutlineIcon